export const getSanityImages = (partnerOverride?: string) => {
  switch (partnerOverride) {
    case 'castorama':
      return {
        housePin:
          'https://cdn.sanity.io/images/nmid0lyc/production/68b0ee766c344d5bd1c3366bc05b7682a6afc5a4-454x300.svg?h=800&q=90&auto=format',
        solarPanel:
          'https://cdn.sanity.io/images/nmid0lyc/production/d4e4b040a95555668cdd31590927321d99c858a0-454x300.svg?h=800&q=90&auto=format',
        houseWithPanels:
          'https://cdn.sanity.io/images/nmid0lyc/production/f169523da99c89b67fffcb7c86072061fe45770c-454x300.svg?h=800&q=90&auto=format',
      };
    default:
      return {
        housePin:
          'https://cdn.sanity.io/images/nmid0lyc/production/02debdb8645ebdd4bd228cc4fbe15075df6c5fd1-454x300.svg?h=800&q=90&auto=format',
        solarPanel:
          'https://cdn.sanity.io/images/nmid0lyc/production/fa313879df06c20092fc44afbf2e914b6a64424f-454x300.svg?h=800&q=90&auto=format',
        houseWithPanels:
          'https://cdn.sanity.io/images/nmid0lyc/production/a76b7783c5ef23cda6d1ff83ac557b9248090e35-454x300.svg?h=800&q=90&auto=format',
      };
  }
};
